<div [className]="'message-block message-block__' + type">
    <mat-icon svgIcon="alert-exclamation"></mat-icon>
    <div class="message-block__text">{{ message }}</div>
</div>
